import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useCountdown } from "@/components/AuctionCard";
import { CardPhoto, money } from "@/components/auction/AuctionUI";
import { Trophy, X } from "lucide-react";

const KEY = "hittcg_auction_pay_dismissed";

function Body({ p, onGo, onClose }) {
  const left = useCountdown(p.deadline);
  const won = p.rank === 1;
  return (
    <div className="sx fixed inset-0 z-[60] bg-black/75 backdrop-blur-sm flex items-end sm:items-center justify-center" data-testid="auction-pay-reminder">
      <div className="relative w-full sm:max-w-md rounded-t-[28px] sm:rounded-[28px] border border-[#34D399]/45 p-6 sx-rise"
           style={{ background: won ? "linear-gradient(180deg,#0c1a15,#0b0f0d)" : "linear-gradient(180deg,#1a140a,#100d08)" }}>
        <button type="button" onClick={onClose} aria-label="Cerrar" data-testid="auction-pay-reminder-close" className="absolute top-4 right-4 text-white/50 hover:text-white"><X size={20} /></button>
        <div className="sx-mono text-[10px] tracking-[.14em] flex items-center gap-2" style={{ color: won ? "#34D399" : "#fbbf24" }}>
          <Trophy size={13} /> {won ? "GANASTE UNA SUBASTA" : "REPECHAJE"}
        </div>
        <div className="flex items-center gap-4 mt-4">
          <CardPhoto path={p.photo} alt={p.product_name} w={60} h={84} size={300} rotate={-3} glow="green" />
          <div className="min-w-0">
            <h2 className="sx-h text-[26px]">{won ? <>¡Ganaste <span className="sx-it">{p.product_name}!</span></> : <>Te ofrecemos <span className="sx-it">{p.product_name}</span></>}</h2>
            <div className="sx-price text-[28px] text-[#34D399] mt-2">{money(p.amount)} <span className="text-sm text-white/50 font-normal">+ envío</span></div>
          </div>
        </div>
        <div className="mt-4 rounded-[14px] border border-[#FF4438]/45 bg-[#FF4438]/[.08] p-3 text-[13px] text-white/75">
          {won || p.accepted
            ? <>Tienes <b className="sx-mono text-[#FF4438]">{left}</b> para pagar. Si no pagas a tiempo, <b className="text-[#ff6b61]">tu cuenta será BANEADA</b>.</>
            : <>El ganador no pagó y la subasta pasó a ti por ser el siguiente postor. Tienes <b className="sx-mono text-[#FF4438]">{left}</b> para decidir. Puedes rechazarla sin penalidad; solo si la aceptas debes pagar a tiempo.</>}
        </div>
        <button type="button" onClick={onGo} data-testid="auction-pay-reminder-go" className="sx-btn w-full h-[56px] text-base mt-5">{won || p.accepted ? "Pagar ahora" : "Ver oferta"}</button>
        <button type="button" onClick={onClose} data-testid="auction-pay-reminder-later" className="sx-btn-ghost w-full h-12 mt-2.5 text-sm">Más tarde</button>
      </div>
    </div>
  );
}

// Aviso global: al entrar a HitTCG, si ganaste una subasta y no has pagado, te lleva al pago.
export function AuctionPayReminder() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!user) { setItems([]); return; }
    api.get("/me/auction-pending-payments").then((r) => setItems(r.data.results || [])).catch(() => {});
  }, [user, pathname]);
  const dismissed = JSON.parse(sessionStorage.getItem(KEY) || "[]");
  const p = items.find((x) => !dismissed.includes(x.auction_id));
  if (!p || pathname.startsWith("/subastas/pagar") || pathname.startsWith("/order") || pathname.startsWith("/mock-pay")) return null;
  const close = () => { sessionStorage.setItem(KEY, JSON.stringify([...dismissed, p.auction_id])); setItems([...items]); };
  return <Body p={p} onClose={close} onGo={() => { close(); navigate(`/subastas/pagar/${p.auction_id}`); }} />;
}

export default AuctionPayReminder;
